module.exports = __webpack_public_path__ + "static/Averta-Regular-0742f843ede68f4486fad90c346058e9.woff";